import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentOrderAddress } from "@redotech/redo-fulfillment-customs-common/fulfillment-order-address";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { Tooltip } from "@redotech/redo-web/tooltip/tooltip";

const catalogEntry = fgColumnEntries["fulfillment-location"];

function addressToString(address: FulfillmentOrderAddress) {
  return `${address.address1 || ""} ${address.address2 || ""} ${address.city || ""} ${address.province || ""} ${address.zip || ""} ${address.countryCode || ""}`;
}

export const FulfillmentLocationColumn: Column2<FulfillmentGroupData> = {
  key: catalogEntry.key,
  title: catalogEntry.title,
  alignment: ColumnAlignment.LEFT,
  renderNormalCell: ({ row }) => (
    <Tooltip title={addressToString(row.originAddress)}>
      <div>
        <RedoTableTextCell text={row.originAddress.name || ""} />
      </div>
    </Tooltip>
  ),
  width: catalogEntry.defaultWidth,
  sort: catalogEntry.sortDirection,
};
